<template>
  <div class="balance-box rounded flex flex-col">
    <div v-if="loading" class="w-full h-full flex items-center justify-center">
      <Spin size="1em"></Spin>
    </div>

    <div class="w-full h-full" v-else-if="data.length > 0">
      <VChart class="chart" :option="option" style="height: 240px"></VChart>
    </div>
    <div
      v-if="data.length == 0 && !loading"
      class="w-full h-full flex items-center text-xs text-white-070 mt-2"
    >
      {{ text || '' }}
      <div v-if="!text" class="flex items-center justify-center">
        <img
          src="@/assets/bgs/no_data.avif"
          alt="no daos data found"
          class="relative"
        />
        <div class="text-white-040 absolute">No Data</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Spin from '@/components/Spin.vue';
import { formatDate, formatVal } from '@/utils';
import * as echarts from 'echarts';
import { LineChart } from 'echarts/charts';
import {
  LegendComponent,
  TitleComponent,
  TooltipComponent,
} from 'echarts/components';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { computed, defineProps, inject } from 'vue';
import VChart from 'vue-echarts';
const daoPageInfo = inject('daoPageInfo');
use([
  CanvasRenderer,
  LineChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
]);

const props = defineProps({
  isCustom: { type: Boolean, default: true },

  data: {
    type: Array,
    default: () => [],
  },
  loading: { type: Boolean, default: true },
  text: {
    type: String,
    default: 'No Data',
  },
});

const data = computed(() => {
  return props.data;
});
const lineItem = {
  text: 'FT VAULT',
  color: daoPageInfo.isCustom.value
    ? daoPageInfo.vueState.customClass === 'ape'
      ? '#0623CBFF'
      : '#FA34F2FF'
    : '#5EFF6AFF',
  offset1: daoPageInfo.isCustom.value
    ? daoPageInfo.vueState.customClass === 'ape'
      ? '#0623CB66'
      : '#FA34F266'
    : '#5EFF6A66',

  offset2: daoPageInfo.isCustom.value
    ? daoPageInfo.vueState.customClass === 'ape'
      ? '#0623CB00'
      : '#FA34F200'
    : '#1E1F2100',
};
const option = computed(() => {
  let min = 0;

  data.value.forEach((x) => {
    if (min == 0) {
      min = x[1];
    } else {
      min = Math.min(min, x[1]);
    }
  });
  min *= 0.9;

  return {
    grid: {
      top: '20',
      left: '20',
      right: '20',
      bottom: '20',
    },
    tooltip: {
      trigger: 'axis',
      borderColor: '#FFFFFF66',
      backgroundColor: '#1e1f21bb',
      textStyle: {
        color: '#fff',
      },
      formatter: (config) => {
        const [time, value] = config[0].data;
        return `Price: $${formatVal(value, {
          bit: 2,
          omit: true,
        })}<br/>${formatDate(time, 'YYYY-MM-DD HH:mm:ss')}`;
      },
    },
    xAxis: {
      type: 'time',
      axisLabel: {
        formatter(value, index) {
          return formatDate(value, 'MMM DD');
        },
      },
    },
    yAxis: {
      show: false,
      splitLine: {
        show: false,
      },
      type: 'value',
      min,
    },
    color: lineItem.color,
    series: [
      {
        data: data.value,
        type: 'line',
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: lineItem.offset1 },
            { offset: 1, color: lineItem.offset2 },
          ]),
        },
        symbolSize: 0,
        markPoint: {
          label: {
            color: '#FFFFFF66',
            show: true,
            position: 'top',
            distance: 7,
            offset: [1, 1],
            formatter: ({ data }) => {
              const { name, value } = data;
              return `$${formatVal(value, { bit: 2, omit: true })}`;
            },
          },
          symbol: 'circle',
          symbolSize: 10,
          symbolOffset: [0, 0],
          data: [
            {
              type: 'max',
              name: 'Max',
            },
            {
              type: 'min',
              name: 'Min',
            },
          ],
        },
      },
    ],
  };
});

/* 图表数据的完整性还有待调整 */
// const option = computed(() => {
//   console.log('OptionValue', data.value, props.cutPoint);

//   const series = {
//     type: 'scatter',
//     data: data.value.map((x) => [x.tradeTime, +x.historyPrice]),
//     symbolSize: 8,
//   };

//   if (props.cutPoint) {
//     series.markLine = {
//       silent: true,
//       symbol: 'none',
//       label: {
//         color: '#fff',
//         position: 'end',
//         formatter: 'Cut Time',
//       },
//       lineStyle: {
//         type: 'solid',
//         color: '#fff',
//       },
//       data: [
//         {
//           name: 'Cut Time',
//           xAxis: props.cutPoint,
//         },
//       ],
//     };
//   }

//   return {
//     grid: {
//       top: '30',
//       left: '30',
//       right: '20',
//       bottom: '20',
//     },
//     xAxis: {
//       // show: false,

//       axisLine: {
//         lineStyle: {
//           color: '#fff',
//         },
//       },

//       splitLine: {
//         show: false,
//       },
//       axisLabel: {
//         color: '#ffffff4d',
//         formatter: (value) => dayjs(value).format('MMM DD'),
//       },
//       min:
//         data.value.length - 1 < 0
//           ? 0
//           : data.value[data.value.length - 1].tradeTime,
//       max: data.value[0].tradeTime,
//     },
//     yAxis: {
//       axisLabel: {
//         color: '#ffffff4d',
//       },
//       splitLine: {
//         show: false,
//       },
//       axisLine: {
//         lineStyle: {
//           color: '#fff',
//         },
//       },
//       // show: false,
//     },
//     tooltip: {
//       axisPointer: {
//         type: 'cross',
//         crossStyle: {
//           color: '#FFFFFF66',
//           type: 'solid',
//         },
//         label: {
//           show: false,
//           formatter: ({ axisDimension, value }) => {
//             if (axisDimension == 'x') {
//               return '';
//             }
//             return value;
//           },
//         },
//       },
//       borderColor: '#FFFFFF66',
//       backgroundColor: '#1e1f21',
//       textStyle: {
//         color: '#fff',
//       },
//       formatter: ({ componentType, data }) => {
//         if (componentType == 'markLine') {
//           return '';
//         }
//         return `${data[1]} ETH <br/> ${dayjs(data[0]).format(
//           'MMM DD YYYY  hh:mmA',
//         )} `;
//       },
//     },
//     color: '#FF5585FF',
//     series: [series],
//   };
// });
</script>

<style scoped>
.chart {
  width: 100%;
  height: 100%;
}
</style>
